var Collection         = require("Collection"),
    Widget             = require("./Widget/Widget"),
    Button             = require("./Widget/Button"),
    ButtonGroup        = require("./Widget/ButtonGroup"),
    ZoomControl        = require("./Widget/ZoomControl"),
    LayerSwitcher      = require("./Widget/LayerSwitcher/LayerSwitcher"),
    DistanceMeasure    = require("./Widget/DistanceButton"),
    Window             = require("./Widget/Window/Window"),
    Panel              = require("./Widget/Panel"),
    Legend             = require("./Widget/Legend/Legend"),
    AreaButton         = require("./Widget/AreaButton"),
    LegendGroup        = require("./Widget/LegendGroup"),
    Searchbar          = require("./Widget/SearchBar/SearchBar"),
    ModalMessage       = require("./Widget/ModalMessage"),
    DropDown           = require('./Widget/DropDown'),
    LabelButton        = require('./Widget/LabelButton'),
    MeasureToolChanger = require('./Widget/MeasureToolChanger');

var widgetClassList = {
    'Button'            :Button,
    'ButtonGroup'       :ButtonGroup,
    'ZoomControl'       :ZoomControl,
    'LayerSwitcher'     :LayerSwitcher,
    'DistanceButton'    :DistanceMeasure,
    'AreaButton'        :AreaButton,
    'Window'            :Window,
    'Panel'             :Panel,
    'Legend'            :Legend,
    'LegendGroup'       :LegendGroup,
    'SearchBar'         :Searchbar,
    'ModalMessage'      :ModalMessage,
    'DropDown'          :DropDown,
    'LabelButton'       :LabelButton,
    'MeasureToolChanger':MeasureToolChanger
};

var WidgetManager = Collection.extend({

    /**
     *
     */
    initialize: function(view, widgets, options) {
        var that = this;

        WidgetManager.__super__.initialize.call(that, widgets, options);

        that._view = view;

        that._mapElements = that._view._elements;
    },

    /**
     *
     * @param widget
     * @param options
     * @return {WidgetManager}
     */
    addWidget: function(widget, options){
        var that = this,
            newWidget;

        options || (options = {});

        options.view = that._view;

        if (typeof widget == 'string' && widget in widgetClassList) {
            newWidget = new widgetClassList[widget](options);
        } else if (widget instanceof Widget) {
            newWidget = widget;
        } else {
            throw new TypeError("Widget not supported. It should be instance of Widget or predefined widget code name (string)");
        }

        that.add(newWidget);
        that._mapElements['container'].appendChild(newWidget.getContainer()[0]);
        newWidget.onAdd(that._view);

        return that;
    },
    
    /**
     * Удаляет виджет из коллекции
     * @param  {Object.Widget} - Объект виджета, который нужно удалить
     * @return {Object.WidgetManager} - Коллекция виджетов
     */
    removeWidget: function(widget_object){
        var that = this;

        that._mapElements['container'].removeChild(widget_object.getContainer()[0]);
        widget_object.onRemove(that._view);
        that.remove(widget_object);
        return that;
    },

    /**
     *
     */
    hideWidgets: function() {
        var that = this;
        that.each(function(el){
            el.hide();
        });
    },

    /**
     *
     */
    showWidgets: function() {
        var that = this;
        that.each(function(el){
            el.show();
        });
    },

    getByName: function(name, all) {
        var that = this;
        var i;
        var res = [];
        var item;

        for (i = 0; i < that._items.length; i++) {
            item = that._items[i];
            if (item.getName() === name) {
                if (!all) {
                    return item;
                } else {
                    res.push(item);
                }
            }
        }
        return res;
    }
});

module.exports = WidgetManager;



//////////////////
// WEBPACK FOOTER
// ./src/View/WidgetManager.js
// module id = 198
// module chunks = 0